(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-footer"]) return;
  try {
    
if (!customElements.get('tsh-newsletter-form')) {
  customElements.define('tsh-newsletter-form', class extends HTMLElement {
    connectedCallback() {
      this.enhance = () => {
        const email = this.querySelector('input[name="email_address"]');
        const name = this.querySelector('input[name="fields[first_name]"]');
        if (email) { email.type = 'email'; email.autocomplete = 'email'; email.inputMode = 'email'; }
        if (name) name.autocomplete = 'given-name';
        if (email && name) this.observer?.disconnect();
      };
      this.observer = new MutationObserver(this.enhance);
      this.observer.observe(this, {childList:true,subtree:true});
      this.enhance();
      this.visibility = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.visibility.disconnect();
        if (this.querySelector('script[data-uid]')) return;
        const script = document.createElement('script');
        script.async = true;
        script.dataset.uid = this.dataset.uid;
        script.src = this.dataset.embedUrl;
        this.insertBefore(script, this.querySelector('.tsh-newsletter__note'));
      }, {rootMargin:'500px'});
      this.visibility.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.visibility?.disconnect(); }
  });
}

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-tsh-cookie-preferences]');
  if (!button) return;
  const status = button.parentElement.querySelector('[role="status"]');
  button.disabled = true;
  status.textContent = '';
  try {
    if (!window.privacyBanner) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    await window.privacyBanner.showPreferences();
  } catch (_) {
    status.textContent = button.dataset.errorText;
  } finally {
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsh-book-shelf')) {
  customElements.define('tsh-book-shelf', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.tsh-hero__viewport');
      this.books = [...this.querySelectorAll('.tsh-hero__book')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.paused = false;
      this.abort = new AbortController();
      this.hovered = false;
      this.focused = false;
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {this.hovered = true;this.update();}
      }, {signal:this.abort.signal});
      this.addEventListener('pointerleave', () => {this.hovered = false;this.update();}, {signal:this.abort.signal});
      this.addEventListener('focusin', () => {this.focused = true;this.update();}, {signal:this.abort.signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {this.focused = this.contains(document.activeElement);this.update();}), {signal:this.abort.signal});
      this.reduced.addEventListener('change', () => this.update(), {signal:this.abort.signal});
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.update();
    }
    update() {
      cancelAnimationFrame(this.frame);
      this.moving = this.dataset.enabled === 'true' && !this.reduced.matches;
      this.dataset.moving = String(this.moving);
      this.dataset.active = String(this.moving && this.visible && !this.hovered && !this.focused);
      if (this.dataset.active === 'true') {
        this.last = 0;
        this.frame = requestAnimationFrame(time => this.highlight(time));
      }
    }
    highlight(time) {
      if (time-this.last > 120) {
        const bounds = this.viewport.getBoundingClientRect();
        const center = bounds.left+bounds.width/2;
        let closest = null, distance = Infinity;
        this.books.forEach(book => {
          const rect = book.getBoundingClientRect();
          const next = Math.abs(rect.left+rect.width/2-center);
          if (next<distance) {closest=book;distance=next;}
        });
        this.books.forEach(book => book.classList.toggle('is-featured', book===closest));
        this.last=time;
      }
      this.frame=requestAnimationFrame(next => this.highlight(next));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-language-showcase"]) return;
  try {
    
if(!customElements.get('tsh-language-scroll')){
 customElements.define('tsh-language-scroll',class extends HTMLElement{
  connectedCallback(){
   this.words=[...this.querySelectorAll('[role="listitem"]')];this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.hovered=false;this.focused=false;this.visible=false;
   this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen'){this.hovered=true;this.update();}},{signal:this.abort.signal});
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.update();},{signal:this.abort.signal});
   this.addEventListener('focusin',()=>{this.focused=true;this.update();},{signal:this.abort.signal});
   this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.update();}),{signal:this.abort.signal});
   this.reduced.addEventListener('change',()=>this.update(),{signal:this.abort.signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});this.observer.observe(this);this.update();
  }
  update(){cancelAnimationFrame(this.frame);this.dataset.active=String(this.visible&&!this.hovered&&!this.focused&&!this.reduced.matches);if(this.visible&&!this.reduced.matches){this.last=0;this.highlight(performance.now());}}
  highlight(time){if(time-this.last>120){const box=this.getBoundingClientRect(),center=box.top+box.height/2;let best=null,distance=Infinity;this.words.forEach(word=>{const rect=word.getBoundingClientRect(),next=Math.abs(rect.top+rect.height/2-center);if(next<distance){best=word;distance=next;}});this.words.forEach(word=>word.classList.toggle('is-active',word===best));this.last=time;}if(this.dataset.active==='true')this.frame=requestAnimationFrame(next=>this.highlight(next));}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tsh-offer-strip')){
 customElements.define('tsh-offer-strip',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.hovered=false;this.focused=false;
   this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'||event.pointerType==='pen'){this.hovered=true;this.update();}},{signal:this.abort.signal});
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.update();},{signal:this.abort.signal});
   this.addEventListener('focusin',()=>{this.focused=true;this.update();},{signal:this.abort.signal});
   this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.update();}),{signal:this.abort.signal});
   this.reduced.addEventListener('change',()=>this.update(),{signal:this.abort.signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});this.observer.observe(this);this.update();
  }
  update(){this.dataset.active=String(this.visible&&!this.hovered&&!this.focused&&!this.reduced.matches);}
  disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-preview-library"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsh-preview-library')) {
  customElements.define('tsh-preview-library', class extends HTMLElement {
    connectedCallback() {
      if (this.filterHandler) return;
      this.cards = [...this.querySelectorAll('[data-preview-book]')];
      const controls = this.querySelector('[data-preview-controls]');
      if (!controls || !this.cards.length) return;
      controls.hidden = false;
      this.filterHandler = event => {
        const button = event.target.closest('[data-preview-filter]');
        if (!button || !this.contains(button)) return;
        const selected = button.dataset.previewFilter;
        let visible = 0;
        this.cards.forEach(card => {
          const matches = selected === 'all' || card.dataset.previewKinds.split(/\s+/).includes(selected);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        this.querySelectorAll('[data-preview-controls] [data-preview-filter]').forEach(control => control.setAttribute('aria-pressed', String(control.dataset.previewFilter === selected)));
        const count = this.querySelector('[data-preview-count]');
        count.textContent = count.dataset.countLabel.replace('__COUNT__', String(visible));
        this.querySelector('[data-preview-empty]').hidden = visible !== 0;
      };
      this.addEventListener('click', this.filterHandler);
    }
    disconnectedCallback() {
      if (this.filterHandler) this.removeEventListener('click', this.filterHandler);
      this.filterHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-quality"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsh-bookmaking-video')) {
  customElements.define('tsh-bookmaking-video', class extends HTMLElement {
    connectedCallback() {
      this.video=this.querySelector('video');
      if (!this.video) return;
      this.video.setAttribute('aria-hidden','true');
      this.video.muted=true;
      this.button=this.querySelector('button');
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.abort=new AbortController();
      this.visible=false;
      this.paused=false;
      this.button.addEventListener('click',()=>{
        this.paused=!this.paused;
        this.button.setAttribute('aria-pressed',String(this.paused));
        this.button.textContent=this.paused ? this.button.dataset.play : this.button.dataset.pause;
        this.update();
      },{signal:this.abort.signal});
      this.reduced.addEventListener('change',()=>this.update(),{signal:this.abort.signal});
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries[0].isIntersecting;
        this.update();
      },{rootMargin:'120px'});
      this.observer.observe(this);
      this.update();
    }
    update() {
      this.button.hidden=this.reduced.matches;
      if(this.visible&&!this.paused&&!this.reduced.matches) this.video.play().catch(()=>{this.button.textContent=this.button.dataset.play;});
      else this.video.pause();
    }
    disconnectedCallback(){this.video?.pause();this.observer?.disconnect();this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-translation-rights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsh-translation-rights')) {
    customElements.define('tsh-translation-rights', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const book = this.querySelector('[data-rights-book]');
        const fields = this.querySelector('[data-rights-fields]');
        const notice = this.querySelector('[data-rights-wiley]');
        if (!book || !fields || !notice) return;
        const sync = () => {
          const wiley = book.selectedOptions[0]?.dataset.rightsOwner === 'wiley';
          notice.hidden = !wiley;
          fields.hidden = wiley || !book.value;
          fields.disabled = wiley || !book.value;
          book.setAttribute('aria-describedby', wiley ? notice.id : '');
        };
        notice.id = `${book.id}-wiley`;
        const wileyOption = book.querySelector('[data-rights-owner="wiley"]');
        if (wileyOption) wileyOption.disabled = false;
        book.addEventListener('change', sync, { signal:this.abort.signal });
        this.querySelector('form').addEventListener('submit', event => {
          if (book.selectedOptions[0]?.dataset.rightsOwner === 'wiley') {
            event.preventDefault();
            sync();
          }
        }, { signal:this.abort.signal });
        window.addEventListener('pageshow', sync, { signal:this.abort.signal });
        sync();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-translations"]) return;
  try {
    
if(!customElements.get('tsh-translation-directory')){
  customElements.define('tsh-translation-directory',class extends HTMLElement{
    connectedCallback(){
      this.form=this.querySelector('form');
      this.cards=[...this.querySelectorAll('[data-book][data-language]')];
      this.count=this.querySelector('.tsh-directory__count');
      this.empty=this.querySelector('.tsh-directory__empty');
      this.abort=new AbortController();
      for(const field of ['book','language']){
        const select=this.form.elements[field];
        [...new Set(this.cards.map(card=>card.dataset[field]))].sort((a,b)=>a.localeCompare(b)).forEach(value=>{
          const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);
        });
      }
      this.form.hidden=false;this.count.hidden=false;
      this.form.addEventListener('submit',event=>{event.preventDefault();this.filter(true);},{signal:this.abort.signal});
      this.form.addEventListener('input',()=>this.filter(true),{signal:this.abort.signal});
      this.form.addEventListener('reset',()=>requestAnimationFrame(()=>this.filter(true)),{signal:this.abort.signal});
      window.addEventListener('popstate',()=>this.readUrl(),{signal:this.abort.signal});
      this.readUrl();
    }
    normalize(value){return value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim();}
    readUrl(){
      const params=new URL(location.href).searchParams;
      for(const name of ['search','book','language'])this.form.elements[name].value=params.get(name)||'';
      this.filter(false);
    }
    filter(write){
      const search=this.normalize(this.form.elements.search.value);
      const book=this.form.elements.book.value,language=this.form.elements.language.value;
      let visible=0;
      this.cards.forEach(card=>{
        const matches=(!book||card.dataset.book===book)&&(!language||card.dataset.language===language)&&(!search||this.normalize(card.textContent).includes(search));
        card.hidden=!matches;if(matches)visible++;
      });
      this.count.textContent=visible+' / '+this.cards.length;
      this.empty.hidden=visible!==0;
      if(write){
        const url=new URL(location.href);
        for(const name of ['search','book','language']){const value=this.form.elements[name].value;if(value)url.searchParams.set(name,value);else url.searchParams.delete(name);}
        history.replaceState(null,'',url);
      }
    }
    disconnectedCallback(){this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsh-wholesale-intake"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsh-wholesale-intake')) {
  customElements.define('tsh-wholesale-intake', class extends HTMLElement {
    connectedCallback() {
      if (this.quantityHandler) return;
      this.querySelector('[data-quote-success]')?.focus();
      this.form = this.querySelector('form');
      this.quantities = [...this.querySelectorAll('[data-book-quantity]')];
      if (!this.form || !this.quantities.length) return;
      this.total = this.querySelector('[data-book-total]');
      this.error = this.querySelector('[data-book-error]');
      this.otherBooks = this.querySelector('[data-other-books]');
      this.quantityHandler = () => {
        let total = 0;
        this.quantities.forEach(input => {
          const count = Number(input.value || 0);
          const valid = Number.isSafeInteger(count) && count >= 0;
          input.setCustomValidity(valid ? '' : this.error.textContent);
          if (valid) total += count;
        });
        const otherTitles = Boolean(this.otherBooks?.value.trim());
        if (total === 0 && !otherTitles) this.quantities[0].setCustomValidity(this.error.textContent);
        this.total.hidden = false;
        this.total.textContent = this.total.dataset.totalLabel.replace('__COUNT__', String(total));
        if (total > 0 || otherTitles) this.error.hidden = true;
      };
      this.invalidHandler = event => {
        if (!event.target.matches('[data-book-quantity]')) return;
        this.error.hidden = false;
      };
      this.form.addEventListener('input', this.quantityHandler);
      this.form.addEventListener('invalid', this.invalidHandler, true);
      this.quantityHandler();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('input', this.quantityHandler);
      this.form?.removeEventListener('invalid', this.invalidHandler, true);
      this.quantityHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
